import axios from 'axios';

import chronosApi from '@chronos/api-client/chronosApi';
import trelloApi from '@chronos/api-client/trelloApi';

axios.interceptors.response.use((r) => r.data);
const req = (params) => axios(params);

const config = {
  trelloApiKey: process.env.TRELLO_DEVELOPER_API_KEY,
  trelloIdPlugin: process.env.TRELLO_ID_PLUGIN,

  pwaAuthUrl: process.env.PWA_AUTH_URL,

  useSentry: process.env.USE_SENTRY === 'true',
  ignoreErrors: [
    'PostMessageIO:PluginDisabled',
    'Plugin not enabled on board',
    /^Unable to determine desired height for.*/,
  ],

  chronosApiUrl: process.env.CHRONOS_API_URL,
  chronosSocketUrl: process.env.CHRONOS_SOCKET_URL,
  logLevel: Number(process.env.LOGLEVEL ?? '5', 10),
  loggerUrl: `${process.env.CHRONOS_API_URL}/trello/logger`,

  trelloTokens: JSON.parse(process.env.TRELLO_TOKENS ?? '{}'),
  developerIds: JSON.parse(process.env.DEVELOPER_IDS ?? '[]'),
  testWorkspaceId: process.env.TRELLO_TEST_WORKSPACE_ID,
};

trelloApi.init({ req });
chronosApi.init({ req, baseUrl: config.chronosApiUrl });

export default config;
